import {request} from "@/utils/request";
// 获取用户信息
export function selectByUser() {
    return request({
        url:'/user/selectByUser',
        method:'post',
    })
}
// 注销
export function loginOut() {
    return request({
        url:'/user/loginOut',
        method:'post',
    })
}

// 未登录预约
export function insertTraitorSubscribe(data) {
    return request({
        url:'/login/insertTraitorSubscribe',
        method:'post',
        data
    })
}

// 未登录预约验证码
export function sendYY(data) {
    return request({
        url:'/login/sendYY',
        method:'get',
        params:data
    })
}


// 登录预约验证码
export function sendMM(data) {
    return request({
        url:'/traitorSubscribe/sendYY',
        method:'get',
        params:data
    })
}


// 登录预约
export function insertTraitorSubscribeMM(data) {
    return request({
        url:'/traitorSubscribe/insertTraitorSubscribe',
        method:'post',
        data
    })
}
